<script>
    export default {
        computed: {
            // The names are put in the store by the click on the main page; after
            // F5 the store is empty, so fall back to the tree by the ids in the
            // URL (869fch4ym).
            fromTree() {
                const q = this.$route.query;
                const provider = this.$store.getters.PROVIDERS_AND_GAMES
                    .find((p) => String(p.id) === String(q.providerID));
                const game = provider?.game_name?.find((g) => String(g.id) === String(q.gameID));
                return { provider: provider?.name ?? null, game: game?.name ?? null };
            },
            selectProvider() { return this.$store.getters.SELECT_PROVIDER ?? this.fromTree.provider },
            selectGame() { return this.$store.getters.SELECT_GAME ?? this.fromTree.game },
            visible() {
                return this.selectProvider != null;
            }
        },
        created() {
            if (this.$store.getters.SELECT_PROVIDER == null && this.$route.query.providerID != null) {
                this.$store.dispatch('CHECK_PROVIDERS_AND_GAMES');
            }
        },
    }
</script>

<template>
    <div
        class="right_header"
        v-if="visible"
    >
        <label>
            {{ selectProvider }} - {{ selectGame }}
        </label>
    </div>
</template>
